// extracted by mini-css-extract-plugin
module.exports = {"centerContent":"SchoolBlocksHeader_centerContent__9wkU0"};